import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { useTenantFormatter } from "components/BudgetBuilder/shared/TenantFormatter";
import Table from "components/Table";
import { budgetBuilderSelectors } from "store/selectors";
import { loadVersion } from "store/actions/budgetBuilder";


export const VersionRow = ({ version, versions }) => {
	const cachedPeopleById = useSelector(budgetBuilderSelectors.cachedPeopleById);
	const { dateTimeFormatter } = useTenantFormatter();

	const name = useMemo(
		() => cachedPeopleById?.[version?.creatorId]?.name,
		[ cachedPeopleById, version.creatorId ]
	);

	const date = useMemo(
		() => dateTimeFormatter(version?.date),
		[ dateTimeFormatter, version.date ]
	);

	const rollbackText = useMemo(
		() => {
			if (version?.rollbackToInstanceId) {
				for (let savedVersion of versions) {
					if (savedVersion.caseInstanceId === version?.rollbackToInstanceId) {
						return `Restored from ${dateTimeFormatter(savedVersion.date)}`;
					}
				}
			}

			return null;
		}, [ dateTimeFormatter, version.rollbackToInstanceId, versions ]
	);

	const onClick = () => loadVersion(version);

	return (
		<Table.Row onClick={onClick}>
			<Table.Cell>{date}</Table.Cell>
			<Table.Cell>{name}</Table.Cell>
			<Table.Cell>{rollbackText}</Table.Cell>
			<Table.Cell>{version?.note}</Table.Cell>
		</Table.Row>
	);
};
